export const E_TypesReports = {
  simple: 'simple',
  rooms: 'rooms',
  deliveryManifest: 'deliveryManifest',
  contrato: 'contrato',
  duasVias: 'duasVias',
}